import React from "react";
import useLongPress from "../../hooks/useLongPress";

type LongPressMessageWrapperProps = {
  enabled: boolean;
  onLongPress: (rect: DOMRect) => void;
  children: React.ReactElement;
};

// Injects long-press touch handlers onto its single child element via
// React.cloneElement so we don't introduce an extra wrapper div that would
// break chat-ui-kit's `MessageList > Message` direct-child styling.
const LongPressMessageWrapper: React.FC<LongPressMessageWrapperProps> = ({
  enabled,
  onLongPress,
  children,
}) => {
  const handlers = useLongPress({
    onLongPress: (el) => {
      const wrapper =
        (el.querySelector(
          ".cs-message__content-wrapper"
        ) as HTMLElement | null) ?? el;
      onLongPress(wrapper.getBoundingClientRect());
    },
  });

  if (!enabled) return children;

  return React.cloneElement(children, handlers);
};

export default LongPressMessageWrapper;
